import script from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=27aa8f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27aa8f44"]])

export default __exports__